<template>
  <div>
    <h1 class="title">Com'è {{ dogData.name | capitalize }}?</h1>

    <p class="subtitle">
      Dacci qualche indicazione sulla corporatura e quanta attività fisica fa
      {{ dogData.name | capitalize }}
      <strong>per poter calcolare le giuste calorie</strong>!
    </p>

    <form class="form" @submit.prevent>
      <div class="grid grid-cols-1 md:grid-cols-2 gap-8">
        <div class="form-group">
          <label class="form-label important-label" for="dog_name">
            Quanto è {{ sex == 1 ? "attivo" : "attiva" }}
            {{ dogData.name | capitalize }} durante il giorno?
          </label>
          <div class="grid grid-cols-1 gap-4 mt-6">
            <label
              :class="[dog.activityLevel == 90 ? 'checked' : 'unchecked']"
              class="option-radio option-icon"
              for="activity_level_90"
            >
              <input
                v-model.number="$v.dog.activityLevel.$model"
                class="hidden"
                type="radio"
                id="activity_level_90"
                value="90"
              />
              <div class="text-left">
                <div class="option-label">
                  È {{ sex == 1 ? "un dormiglione" : "una dormigliona" }}!
                </div>
                <div class="option-detail">Fa meno di un’ora di camminata al giorno</div>
              </div>
              <svg
                class="w-16 h-16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 146 146"
              >
                <path
                  d="M74 115.6c-3.3 1.6-7.8.5-12.4-.9-1.6-.5-1.9-1.3-2.2-1.9 2.3.7 4.7 1.5 7.1 2 2.1.4 4.2.5 6.4.7.3-.1.7 0 1.1.1zM65.7 119.3c-2.6.5-5.6-1.1-8.6-3-1.1-.7-1.1-1.3-1.2-1.8 1.5.9 3.1 2 4.7 2.7 1.4.7 2.9 1.1 4.4 1.7l.7.4zM15.8 63.4l3-2.8c.9-.9 1.7-.9 2.5-.2.8.6.7 1.9 0 2.5l-3.8 3.2C22.6 71 29 73.6 35.3 76.4l.5-1.4c.5-1.4 2.7-1.7 3.7-.5l.4.4a11 11 0 013.4 5l2.3-2.7c.5-.5 1.3-.9 2-1.1 1.3-.4 2 .4 2 1.5l-.2 4.7c0 .5.1.7.6.8l8.7 1.8a88.5 88.5 0 0015.8 1.5 107.6 107.6 0 0012.9-2.9l-.2-1.3c0-2.7.5-5.4 2.1-7.6a3 3 0 011.4-1.1c.7-.4 1.5-.2 2 .5l2.6 3.3c.8 1 1.6 2.1 2.5 3 .2.2.9.3 1.3.1 2.7-.9 5.3-1.7 7.9-2.7 1.8-.7 3.6-1.7 5.3-2.5l9.8-4.9.5-.3-2.9-2.1-.9-.5c-1.1-.6-1.2-1.3-.2-2 1.1-.8 1.6-.8 2.8.1l3.8 2.9 2.8-2.1c.2-.2.2-.5.2-.8 0-1.6 1.3-3.1 3-2.7.2.1.6-.2.8-.4l2.3-3.1a7 7 0 014.8-3c-.1 1.7-.1 3.3-1.3 4.7-1 1.1-1.8 2.4-2.7 3.6-.3.4-.3.6-.1 1 1.4 2.6-.3 4-2.4 4.6h-.3c-1.6-.8-2 .6-2.7 1.4l4.4 3.8c.4.3.7 1 .7 1.5 0 .4-.4 1-.7 1.2-.3.2-.9 0-1.3-.2l-3.9-3.2-1-.8-5.3 6a117.6 117.6 0 01-26 22.2c-6 3.7-12.4 6.4-19.4 7.7a41 41 0 01-24-2.6c-2.8-1.2-5.4-3-8-4.6-2.5-1.6-5-3.2-7.5-5-1.5-1.1-2.7-2.4-4-3.7a112 112 0 01-15-18L14.1 69l-3.6 2.8-.6.3c-.6.3-1.3.3-1.7-.4-.4-.6-.1-1.1.4-1.6l3.4-3.3.8-.5c-.7-.5-1.1-1-1.6-1.2a3.4 3.4 0 01-2-3.8c.1-.3 0-.6-.1-.9l-2-3.7c-.6-.9-.6-1.8-.2-2.7l.5-1.4c.9.5 1.7.9 2.5 1.5.3.2.5.5.6.9l1.4 3.1c.1.2.5.4.6.4 1.5-.5 3.7 1 3.7 3L16 63l-.1.3-.1.1zm21.9 11.9l-.2-.2.1.3c.1.8 1.1 1.4.4 2.3l3.7 1.6.1-.2-1.2-1.9c-.6.8-1 .8-1.4.1l-1.5-2zM20 70.6l-.2.2.7.5 8.7 7.5c3 2.5 6.1 5 9.3 7.1 3.7 2.4 7.6 4.5 11.5 6.7a23 23 0 006.7 2.7l8 1.5c2.7.5 5.4 1.1 8.2.7l7-1c8.6-1.7 16.6-4.9 24.6-8.5 2-.9 3.7-2.3 5.5-3.5 2.5-1.7 5.2-3.1 7.4-5.2l1.5-1.4 6.8-5.3-.7-.6c-.7-.9-1.3-.6-2.1-.2-2.6 1.4-5.1 2.8-7.8 4a135.8 135.8 0 01-42.7 12.4c-2.2.1-4.5-.3-6.7-.6l-10-1.3c-3.1-.5-6.2-1.1-9.2-2-2.7-.8-5.3-2-7.9-3-2.3-.9-4.6-1.7-6.8-2.8a45.3 45.3 0 01-9.7-6.4c-.7-.8-1.4-1.1-2.1-1.5zm99 9.9l-.2-.2-.5.3-4.6 3.5c-2 1.3-4 2.6-6.1 3.7a92.7 92.7 0 01-7.8 3.6c-4.1 1.6-8.3 3.3-12.6 4.6-3.3 1-6.7 1.6-10 2.3-2.4.5-4.9 1.1-7.3 1.3a36.4 36.4 0 01-17-3 52 52 0 01-6.2-3.2 65.3 65.3 0 01-10-6.4l-6.4-5.2a54 54 0 01-9.2-8l-2.3-2.4c0 .5.1 1 .4 1.4 1.9 3.2 4 6.2 6.5 9l3 3.2 7.3 8.3c2.2 2.5 5.1 4.2 7.8 6.1 3.4 2.5 7.3 4.1 11.1 5.9a28 28 0 0011.4 2.3 58 58 0 0017.2-2.9c8-2.9 15.3-7.2 22.1-12.3l5.3-4 2.5-2.1c.7-.7 1.2-1.5 1.9-2.1 1-1.3 2.4-2.5 3.7-3.7zm-30.3 2.6l8-2.4-3-3.6c-1.5.6-2.9 1.2-4.5 0l-.7 3.6c.8.5 1.4 1.1 2.4.5.2-.2.6-.1.9-.1l-.5.9c-.9.6-1.8.4-2.8-.1l.2 1.2zM45.6 79l-.2-.1-1.5 2.2 4.2 1.4.4-3.9h-1c-.2-.4-.2-.9-.3-1.4-.5.1-.9.5-.8 1.2v1.2l-.5.6-.5-.6.2-.6zm88.2-12.7l-1.6 2c.6 0 1.1.2 1.4.1.8-.5.8-.9.2-2.1zM14.1 60.4l.5 2.3c.4-.8.2-1.6-.5-2.3zm105.5 19.5l-.1-.1-.2.1.1.1.2-.1z"
                  fill="#E82716"
                />
              </svg>
            </label>

            <label
              class="option-radio option-icon"
              for="activity_level_100"
              :class="[dog.activityLevel == 100 ? 'checked' : 'unchecked']"
            >
              <input
                v-model.number="$v.dog.activityLevel.$model"
                class="hidden"
                type="radio"
                id="activity_level_100"
                value="100"
              />
              <div class="text-left">
                <div class="option-label">È normale direi!</div>
                <div class="option-detail">Fa una o due ore di camminata al giorno</div>
              </div>
              <svg
                class="w-16 h-16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 146 146"
              >
                <path
                  d="M71.3 84.4c1.7-.5 2.8.1 3 1.5.1.5-.2 1.2-.5 1.7-.2.4-1 .4-1.5-.1L70.9 86c.1 0 0 0 0 0-.7.4-.9.9-.8 1.7.3 1.8.4 3.6.5 5.4 0 .6.3 1 .8 1.2.5.2 1.1.4 1.7.4 2.1-.1 4.1-.2 6.2-.5a11 11 0 005.7-3.1l4.4-3.6c.3-.2.4-.2.7-.1 1 .5 1.4 1.2 1 2.2a16 16 0 01-5 7.3c-1.8 1.5-4 2.1-6.3 2.4-2.7.3-5.3.9-8 1.3l-2.3.5c-.5.1-.7.4-.8.9a42 42 0 00-1.4 10.5l-.1 8.7a6 6 0 002.6 5l4.1 3.1c-.8 1.6-2.2 2.3-3.9 1.8a11.4 11.4 0 01-7.9-7.6c-.8-2.4-1.7-4.7-2.7-7-.5-1.2-1.4-2.2-2.1-3.3a44.6 44.6 0 01-22.5 7.7l-.1.1a13 13 0 004.7 7.7l1.1.7c.4.2.4.4.3.8-.2.8-.7 1.4-1.6 1.5-2.6.2-5.2-.1-7.1-2.1-1-1-1.7-2.3-2.5-3.5l-2.1-3.6c-.4-.7-1-1.3-1.6-1.9-1-.9-3.2-.9-4.2 0-1.7 1.5-3.6 2.9-5.4 4.3l-1.3 1.3c-.8.9-1.1 1.9-.6 3.1l1 2.5c.1.3.1.6-.2.8-.7.5-1.3.5-2.1 0a5.7 5.7 0 01-2.6-4c-.4-1.6-.7-3.3-.9-5l.2-.9 6.8-10.7 3.7-6.7-2.7-1.5a12.4 12.4 0 01-5.9-15c.5-1.4.9-2.9 1.8-4.1.1-.2.4-.3.6-.4.2.3.4.6.4.9l-.1 3.9c.1 3.3 1.4 6 4.1 8a8 8 0 005.4 1.4l.4-.2c2.5-2.6 5.7-3.7 9.1-4.3 2.3-.4 4.7-.5 7-1.2a20.6 20.6 0 0013.9-12.1c.6-1.4.8-2.9.9-4.4v-.4l-.7.4c-1.7 1.1-3.5 2.3-5.3 3.3a7 7 0 01-2.4.9c-1.3.3-2.3-.7-1.9-2 .3-1.3.8-2.6 1.4-3.9.9-2.1 2-4 3-6.1.7-1.4 1.7-2.6 3.4-3l1.8-.1h3.2l1.9-3.7c1.3-2.3 2.9-4.2 5.3-5.2 1.2-.5 2.5-.7 3.8-.9 2.2-.4 4.5-.6 6.8-.9h.3c.8 1.8-.4 3.2-1.1 4.8 2.1 0 4.2-.3 6.1-1 1.5-.5 2.9-1.3 4.4-1.9.2-.1.5-.3.6-.2.4.3 1 .5 1.1.9l.7 3a4 4 0 01-.3 2.4L81.8 73a15.7 15.7 0 01-6 6 9 9 0 00-3.7 3.5c-.3.4-.5 1.1-.8 1.9zm17.5 5.4l.1-.1-.1.1h-.2l-1.8 1.4a15.4 15.4 0 01-4.2 3 24 24 0 01-10.9 1.6c-1.5 0-2.2-.8-2.5-2.3l-.1-1.4-.2-4.9-4.8.6c-2.2.2-4.5.1-6.6-.7-1.3-.5-2.4-1.3-3.7-2l-3.7 3.4c-2.5 2.4-5.4 4-8.6 5-2.4.8-4.9.9-7.4 1.3a14 14 0 00-8.2 3.7c-1.8 1.7-2.9 4-3.9 6.2-1 2.1-1.8 4.2-2.9 6.2a94 94 0 01-6.8 10.1c-1.1 1.5-1.9 3.1-1.5 5.1a12 12 0 002.2 5.2l.9.8.1-.1-.6-1.4v-.5c.2.1.4.1.4.3l.5 1 .1.3h.1v-.4l-1-3.4c-.2-.7-.1-1.3.3-1.9 1.1-1.6 2.5-2.8 4.1-3.9l2.3-1.7c.9-.6 1.7-1.4 2.6-1.9 2.7-1.7 5.5-3.3 7.7-5.7.2-.2.6-.3.9-.4l.2.2c-1.6 2.5-4 4.3-6.4 6.1l.4.1c4.2.6 8.4.8 12.6.4 6.5-.7 12.5-2.8 18-6.4.4-.3.5-.5.3-.9l-.7-1.8c-.3-.7-.2-1.4.4-2l.1.2 4.8 9.3 3.5 7.6c.7 1.5 1.6 3 3.2 3.8 1 .5 2.1.8 3.3.7l-1.6-1.1-.2-.3.4-.1.3.1 1.7 1.3.5.3.1-.1-.4-.4-2.3-1.7c-2.1-1.3-3.3-3-3.3-5.5l.1-11.2.1-3.4.7-5.4.6-3.7.3-.4.4.4.5 1.5 3.4-.5 8.7-1.4c3.5-.6 5.8-2.6 7.4-5.9l-.9.3-.5.3.1-.7.3-.3 1.2-1.6.1-.4zM28 120.3c-.1 0-.1-.1 0 0-.1 0-.1 0 0 0l.7 1.4c1.3 2.1 2.5 4.1 3.9 6.1 1.4 2.1 4 3 6.3 2.3l-1.7-.7-.3-.3c.1-.1.3-.2.4-.1l1.4.5.3.2.1-.1-.3-.2a9.3 9.3 0 01-3.5-4.1l-1.6-3.8-.5-.5-5.2-.7zm30.9-46.5a2.7 2.7 0 00-2.3 2.4l-.5 4c-.2 2.3.7 3.7 2.9 4.3l3.2.7c3.5.8 6.3-.3 8.5-3.1.5-.7 1-1.4 1.7-2l6.5-5.7.4-.4-.1-.1-1 .4-3.1.9c-.8.2-1.4-.2-1.5-.8-.2-.7.2-2 1.1-2.4v.8c0 .5.4 1 .9.9l1.6-.2c1.5-.4 2.5-1.5 3.6-2.5 2.3-2.3 3.7-5.2 4.9-8.3l-.3.1c-1.7.7-2.4.4-3.1-1.4l-.7-1.6c-.2-.3-.4-.5-.8-.4l-5.4 1-.3.3c-.3.6-.7 1-1.3 1-.6.1-1.1-.1-1.4-.7-.2-.3-.5-.6-.8-.7-.9-.2-1.9-.5-2.9-.5-4.1-.1-6.8 2.1-9 5.3l.7 1.2H54c-1.1-.1-1.7.4-2.4 1.1-1.2 1.4-1.6 3.1-2.3 4.7l4.4 2.3c.3.2.6.2.9 0l2.7-1.3c.4.1 1 .2 1.6.7zM23.1 100l-4.5-1.7c-.9-.4-1.7-.5-2.7-.3l-2.2.4-.1.2 3.2 3.1c1.1 1 2.5 1.5 4 1.6l.5-.2 1.8-3.1zm39.1-39.6c1 .1 1.2 0 2-.5.5-.3 1-.6 1.6-.7a40 40 0 014.9 0c.9.1 1.8 0 2.6-.6l-3.6-1.8c-.3-.1-.6-.2-1-.1l-2.4.5c-1.8.4-3.3 1.3-4.1 3.2zm11.3 26.4c-.3-1-.7-1.5-1.5-1.7 0 .3-.1.8.1.9.4.2.6.9 1.4.8zm-33.9 43.3l.1-.2-.6-.3-.1.2.6.3zm31.7-45.5h.1v-.2l-.1.2zm7.9-10.5l.1-.1s-.1-.1-.1 0v.1s0-.1 0 0zM109.3 21.6c.4-.3.6-.1.8.2.5.8 1.1 1.6 1.5 2.5.3.6.7.8 1.3.8 1.8.2 3.6.6 5.3 1.4 1.9.8 3.5 2 4.7 3.6l.4.4.1-1 .3-4.3v-.3c-.3-1.3-.3-1.3.6-2.4 1 .5 1.3 1 .9 2.1-.3.8-.3 1.6 0 2.4.3 1.1.4 2.3.6 3.4 1.5-.2 4-1.7 5.3-5.8.7.8 1 1.5.5 2.5s-1.1 1.9-2 2.6l-3.5 3 .3.6c3.1-.3 6.1-.6 9-1.5 3-.9 5.4-2.8 8-4.6l-.2.7c-.9 3.3-2.2 6.4-3.8 9.4-1.3 2.2-2.9 4-5.1 5.3-1.3.7-1.8 1.9-1.7 3.3l.2 6.6c0 3.3-1.4 6-3.5 8.4l-1.9 2-1.3.8c-.1.1-.4 0-.5-.2V63c1-1.6.9-3.2-.3-4.7-.9-1.2-1.9-2.4-3.1-3.4-2-1.6-3.4-3.6-4.1-6.2l-1 .3-7 1.9a8.2 8.2 0 00-5.4 4.3l-.4.5c-.6-.6-.8-1.3-.8-2.1a19 19 0 012.5-8.9 20 20 0 014.1-4.6l1.9-1.6c.4-.3.5-.6.3-1.1l-1.9-4.1a15.4 15.4 0 01-1.3-7.9l.2-3.8zm18.5 39.2l1.8-2.4c1.5-2.2 2.4-4.7 2.2-7.4l-.5-5.5c-.2-1.6.3-2.7 1.7-3.5.8-.5 1.6-1 2.3-1.7 2.4-2.1 3.9-4.8 5.1-7.8l.4-1.7-1.1.6a14.8 14.8 0 01-7.1 2.2c-1.8 0-3.5.5-5.1 1.1-2 .7-3.4 2.1-4.3 4.1l-3.1 6.7c-.4.9-.7 1.9-.6 2.9a7.7 7.7 0 002.8 4.7c2.3 2.1 4.3 4.5 5.5 7.7zm-23.1-8.3h.1l.2-.1a9.4 9.4 0 015.6-2.8 15 15 0 005.4-1.8c.6-.3 1.1-.8 1.5-1.3 1.9-2.3 3.3-5 4.6-7.7 1.2-2.6 1-5.1-.1-7.6-.5-1-1.1-1.9-1.9-2.6-.9-.8-2-1.1-3.1-1.4-2.2-.6-4.4-1-6.4-2.1l-.4-.1c-.7 4.9 1.5 8.9 3.3 12.9l-3.4 3.6a19.7 19.7 0 00-3.9 5.1c-1 1.9-1.5 3.8-1.5 5.9zM107.8 67.5c1.5.1 2.8-.8 3.7-1.9.8-1 1.3-2.2 1.9-3.3l.4-.5v.6c-.7 1.7-1.6 3.4-3.2 4.6-1 .7-2 1.1-3.2.9a12.2 12.2 0 01-6.1 4.4s-.1.1-.1 0l-.5-.1.3-.3c2-.6 3.7-1.7 5.1-3.2l.6-.7.1-.2c-.6-.4-1.2-.9-1.3-1.7-.1-.7.1-1.1.6-1.5a1 1 0 011.3-.2c.5.2.8.7.7 1.3.1.5-.1 1.1-.3 1.8zm-.4-.1l.3-2c0-.6-.5-.9-1-.6-.4.2-.6.5-.6 1 0 .7.5 1.1 1.3 1.6zM6.4 95.9a7.6 7.6 0 01-3.2-9c.1 3.3 1.2 6.3 3.2 9z"
                  fill="#E82716"
                />
                <path
                  d="M21.7 90.5l-.1-.5c-.2-.6-.1-1.2.2-1.8.9-1.5.7-3 0-4.5l-.3-.6c1.2.4 2 1.7 1.9 3.1a9.3 9.3 0 01-1.7 4.3zM18.8 82c2 1.1 2.1 2.9 2 4.9 0 .7-.6.9-1 1.1v-3c-.1-.9-.6-1.7-.9-2.5l-.1-.5zM6.9 91.9c-1.1-.7-1.6-1.5-1.3-2.7l.4-1.5.9 4.2zM18.8 82s-.1.1 0 0c-.1.1-.1.1 0 0 0 0-.1 0 0 0zM71.8 66.6c0 1-.5 1.6-1.4 1.6-.9 0-1.3-.5-1.3-1.4 0-.7.7-1.7 1.3-1.7.8 0 1.4.6 1.4 1.5zM130.3 49.6c0 2.3-.9 3.6-3 4.2-.2.1-.6 0-.8-.1-2.9-2.2-3.7-5.2-3.2-8.7.3-1.7 2-2.6 3.7-1.8a5 5 0 012.9 4c.3.8.3 1.6.4 2.4zM127.5 37.3c-.1-.7.3-1.1.7-1.6a4.9 4.9 0 014.1-1.3l.7.3c1 .9 1.1 3.4.1 4.3-2.1 2-4.1 1.2-5.5-.9l-.1-.8zM120.9 32.8c0 1.6-1.1 2.7-2.4 3.8-.1.1-.2 0-.4 0-1.8-.7-3.3-1.7-4.5-3.2l-.5-.8c-.5-1.1-.3-2.2.8-2.9a6.1 6.1 0 014.4-.9c.6.1 1.2.6 1.6 1.1.7.7 1 1.7 1 2.9zM108.9 45.5l.3-1a7 7 0 015.2-4l1.1-.1c1.3.1 2 1 1.9 2.2-.2 1.6-.9 2.9-2.5 3.4l-3.1 1.1c-.6.2-1.3.2-1.8-.2-.7-.2-1-.6-1.1-1.4z"
                  fill="#E82716"
                />
              </svg>
            </label>

            <label
              class="option-radio option-icon"
              for="activity_level_120"
              :class="[dog.activityLevel == 120 ? 'checked' : 'unchecked']"
            >
              <input
                v-model.number="$v.dog.activityLevel.$model"
                class="hidden"
                type="radio"
                id="activity_level_120"
                value="120"
              />
              <div class="text-left">
                <div class="option-label">È un uragano!</div>
                <div class="option-detail">Fa più di due ore di camminata al giorno</div>
              </div>
              <svg
                class="w-16 h-16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 146 146"
              >
                <path
                  d="M123 59.3a86 86 0 00-5.9-21.1c-3.5-8.3-8-15.8-15.3-21.5a44 44 0 00-34.3-8.8c-4.5.6-9 1.7-13.5 2.7a25.9 25.9 0 00-14.4 9C34.2 26.3 30 34 25.3 41.3c-.7 1.1-1.4 2.4-1.6 3.6-.4 1.9-.5 3.9-.4 5.8.2 2.1 1.2 4.2 1.2 6.3.3 12.5 1.4 24.8 5.8 36.6l1.5 4.8a3 3 0 00-.7.5l-5.5-7.2c-.4-.6-1.1-1.4-1.6-1.3-1.5 0-3.1 3.6-2.2 4.9 1.4 2.1 2.7 4.2 4.2 6.2 1.8 2.5 3.2 5 1.5 8.2-.5.8-.5 2-.6 3l-.8 6.8c-.3 4.4-1 8.8-.8 13.1.2 5.2 2.3 6 6.6 3 .3-.2.6-.6 1-.7.9-.2 1.8-.5 2.7-.5 1.4 0 2.8.4 4.2.3 2-.1 3.2.5 4.2 2.4a8 8 0 004.5 3.6c2 .5 2.8-1.8 3.7-3.3l.5-.4c2.8 2 4.5 1.8 4.7-.8.2-2.4-.4-4.8-1.1-7.1-.3-1.3-1.6-1.4-2.7-.5l-3.3 2.3-1.1-3.3c5.1-2.9 7.9-6.4 7.4-9.4l-6.5 4.1c0-1.7.4-3 .6-4.3.4-1.9 1.5-2.6 3.4-2.9 3.8-.6 7.6-1.3 11.3-2.5 2-.7 3.8-2.2 5.5-3.6.6-.5.5-1.6.8-2.5-.8 0-1.6-.2-2.3 0a27.1 27.1 0 01-14.6 1.7c2.8-.7 5.7-1.5 8.6-2.1a90.6 90.6 0 0046.4-24.4c.9-.8 2.2-1.4 3.4-1.7 3.2-.7 6.1-1.8 7.4-5.1 2.3-4.7 3.2-10 2.4-15.6zm-71.5 45.1l-2.2.8c-.9.4-1.8 1-2.8 1.3l3.2-3.9c-1-.7-1.6-.9-2.3.7-2.2 4.8-10.3 5.5-13.4 1.2 1.3-1.2 3.3-2.2 1.6-4.5-.1-.1.1-.6.3-.8.9-1.3 5.7-1.7 6.9-.7 3.7 3.2 5.1 3.3 9.7.6.4 1.6 1.1 3.1.9 4.5-.2 1.5-1.4 2.8-3.3 2.5l1.6-.8a2 2 0 00-.2-.9zM46 124c-1.7-3.6.7-13.1 3.9-15.8-2.3 5-4.3 9.9-3.9 15.8zm-1.3 1.3c-4.6-.6-8.8-1.3-12.7-3.6-.4-.3-1-.8-1-1.2-.4-5-.1-9.9 2.1-14.8 4.7 4.3 9.8 2.7 14.9 2a32 32 0 00-3.3 17.6zm-4.2-34.9c3.7.8 7.3 2.3 10.9 3.4-1.6 4.6-5.3 5.5-8 2.3-1.5-1.7-3-2.2-5-1.1l-1.5.4c-1.6-4.5-.8-5.9 3.6-5zm-1.7-2.7c1.4-1.5 3.1-1.8 5-1.4 4.6.9 7.3 2.7 8.3 5.7l-13.3-4.3zm2.7 7.8l.1.8-5.7 1-.1-.6 5.7-1.2zm12.1 0c.5-3.4-.8-5.9-3.6-7.9-4.4-3.2-7.7-2.5-12.7-.4-3.8 1.6-3.2 4.1-4 6.7-.2-.5-.6-1.1-.6-1.6a16.9 16.9 0 0116.1-17.1c5.5-.1 10 1.1 13.4 5.8 4.2 5.7 3.1 16.4-2.4 20.8-.8.6-2.6.7-3.4.2a9.2 9.2 0 01-2.9-3.3c-.4-1 0-2.2.1-3.2zm5.9-18.7c-6.6-5-14.1-3.7-21.4 1.1l.4-5.8c.8-5.1 1.5-10.3 2.6-15.4.3-1.4 1.8-2.5 2.9-3.7 5.9-6.5 11.7-13 17.7-19.4 2.3-2.4 5.1-4.4 7.7-6.4 1.2-.9 2.2-.4 3 .8 5.1 7.2 9 15 12.2 23.2 2.1 5.3 3.6 10.9 5.3 16.4.2.7.1 1.8-.3 2.4a219 219 0 01-26.4 29.8c4.6-8.7 4.2-17-3.7-23zm45.7-55.9c3.9 4.5 7.6 9.2 10 15.1-3.3.7-6.3 1.5-9.4 1.9-7.1.9-13.9 3.1-20.8 5.3-.7.2-2 0-2.3-.5-2.8-4.8-5.4-9.6-8.1-14.5l-.3-.9c6.7-2.8 13.1-6.4 20.5-7.2 1.6-.2 3.2-.3 4.7-.7 2.4-.5 4.2-.2 5.7 1.5zM69.9 9.6l-9.6 8.3c-.4.4-1.2.7-1.6.6a27.6 27.6 0 00-16.5.8c7.7-8.7 18-8 27.7-9.7zM25.3 45.1c4.2-6.9 8.7-13.7 13-20.6 1.5-2.5 3.7-3.5 6.4-3.9a46 46 0 0115.7.7c5.9 1.3 6.5 1.5 8.8 3.9-7.1 4-11.3 10.8-16.5 16.4-3 3.2-6.1 6.5-9.3 9.6-3.2 3.1-7.2 2-11 1.6-1.4-.2-2.7-.7-4.1-1-3.9-.8-5-3.3-3-6.7zm6.5 44.1h-.5l1.5-32.9A156 156 0 0031 92.6a108 108 0 01-5.6-39.5l7.4 1.3 7.5 1.3-2.1 12.1-.4 3.5c-.4 3.7-.2 7.3-3.1 10.5-1.6 1.9-2 4.9-2.9 7.4zm.4 15.1l-2.7 13.2c-.1-4.4-.1-9 2.7-13.2zm-8.3-7.7c-1.3-2-1-3.7.1-4.8l7 8.3-1.2 5c-2.3-3.2-4.2-5.8-5.9-8.5zm4.3 14h.6l-.4 8.2-.8-.1.6-8.1zm4 23.7l-4.7 1.9c-.5-1.6-1.2-3.2-1.4-4.8-.2-1.9-.1-3.8-.1-5.8h.7l2.1 7.5 4 .2c-.4.7-.4 1-.6 1zm8.4-.5c-2.1-.1-4.3-.1-6.3-.7-4.5-1.3-5.5-3.5-4.7-9.4l15.6 4.4c-1.1 1.6-2.1 3.4-3.3 5-.2.4-.9.7-1.3.7zm2.9-.5l-.5-.3 4-5.3.7.5-4.2 5.1zm7.4 2.5c.4-1.7.4-3.1 1-4.1.7-1 2-1.7 3.7-3.1l1.4 7.8-.8.2-.9-2.6h-.4v3.2l-2.2-2.4-.9 1.5-1.5 2.4c-1 1.5-2.1 1.6-3.5.4-2.9-2.4-3.2-4.9-.7-7.8l2.4-2.7 2.4 7.2zm4.2-15l.4.5-4.8 5.2-1-2.6a149 149 0 015.4-3.1zm11.9-12v2l3.6-3.4a6.5 6.5 0 01-4.6 4.2c-3.8 1.1-7.7 2-11.7 2.7-2.3.4-3.8 1-4.3 3.5-.3 1.7-.8 3.3-1.4 5-.2.7-.6 1.3-.9 2l-.7-.2c-1.1-5.3.8-10 3.2-14.5.3-.5 1.9-.8 2.7-.6 4.8 1 9.4.3 14.1-.7zm-13.9-1.9l-.3-.3 2.4-3.6 3 .8-5.1 3.1zm2.6-.1c.6-.6.9-.9 1.3-1.1 8-4.9 14-12 20.1-18.9 4.4-5.1 8.5-10.4 12.8-15.6l.7-.5c4.2 6.3 4.5 6.7 8.4 7.1-2.2 6.8-27.1 25.6-43.3 29zm8.6-1.7c4.7-2.5 9.6-4.8 14.1-7.7 7.1-4.6 14-9.6 19.3-16.2 2.4-2.9 4.5-3.1 7.6-2.4 1.6.4 3.4.5 5.7.9a86.8 86.8 0 01-46.7 25.4zm54.9-29.8c-1 1.6-3.2 2.6-5 3.4-.7.3-2-.8-3-1-2.4-.4-4.8-.5-7.3-.8l-4.9-.7c-3-.5-5.2-2-6.2-4.9L89 59c3.7-.3 7-.8 10.4-.8l20.1-.1c1.4 0 2 .6 2.2 1.9.4 5.3.5 10.7-2.5 15.3z"
                  fill="#E82716"
                />
              </svg>
            </label>
          </div>

          <div v-if="$v.dog.activityLevel.$error" class="error">campo obbligatorio</div>
        </div>

        <div class="form-group">
          <label class="form-label important-label" for="dog_name">
            Come definiresti il fisico
            {{ sex == 1 ? "del tuo" : "della tua" }}
            {{ dogData.name | capitalize }}?
          </label>

          <div class="grid grid-cols-1 gap-4 mt-6">
            <label
              v-for="(bcss, index) in bodyConditionScoreSystem"
              :key="bcss.value"
              class="option-radio option-icon"
              :for="'option-' + index + 1"
              :class="[
                dog.bodyConditionScoreSystem == bcss.value ? 'checked' : 'unchecked',
              ]"
            >
              <input
                :id="'option-' + index + 1"
                v-model.number="$v.dog.bodyConditionScoreSystem.$model"
                class="hidden"
                type="radio"
                :value="bcss.value"
              />
              <span class="option-label">{{ bcss.name }} </span>
              <img class="h-12 w-12" :src="bcss.image" />
            </label>
          </div>

          <div v-if="$v.dog.bodyConditionScoreSystem.$error" class="error">
            campo obbligatorio
          </div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import { required } from "vuelidate/lib/validators";
export default {
  props: {
    wizardData: {
      type: Object,
      required: true,
    },
    dogData: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      sex: null,
      bodyConditionScoreSystem: [
        {
          name: "Molto magro",
          value: 1.2,
          image: this.getImageUrl("01_fitness.svg"),
        },
        {
          name: "Magro",
          value: 1.1,
          image: this.getImageUrl("02_fitness.svg"),
        },
        {
          name: "Ideale",
          value: 1.0,
          image: this.getImageUrl("03_fitness.svg"),
        },
        {
          name: "Robustello",
          value: 0.9,
          image: this.getImageUrl("04_fitness.svg"),
        },
        {
          name: "Sovrappeso",
          value: 0.8,
          image: this.getImageUrl("05_fitness.svg"),
        },
      ],
      dog: {
        activityLevel: null,
        bodyConditionScoreSystem: null,
      },
    };
  },
  validations: {
    dog: {
      activityLevel: {
        required,
      },
      bodyConditionScoreSystem: {
        required,
      },
    },
  },
  methods: {
    getUrl(value) {
      return this.$hostname + "/" + value;
    },
    getImageUrl(value) {
      return this.getUrl("wp-content/uploads/2021/07/" + value);
    },
    submit() {
      this.$v.$touch();
      return new Promise((resolve, reject) => {
        if (!this.$v.$invalid) {
          resolve({
            dog: {
              activityLevel: this.dog.activityLevel,
              bodyConditionScoreSystem: this.dog.bodyConditionScoreSystem,
            },
          });
        } else {
          reject("invalid entry");
        }
      });
    },
  },
  activated() {
    this.dog.activityLevel = this.dogData.activityLevel;
    this.sex = this.dogData.sex;
    this.dog.bodyConditionScoreSystem = this.dogData.bodyConditionScoreSystem;
    this.$v.$reset();
  },
};
</script>
